import { useCallback } from 'react';

export function useDungeonClickBoundary({
  isStorylineActive,
}) {
  const handleRootBoardClick = useCallback((e) => {
    if (isStorylineActive) {
      e.stopPropagation();
      e.preventDefault();
      return;
    }
  }, [isStorylineActive]);

  return {
    handleRootBoardClick,
  };
}

export function stopBoundaryClick(e, fn) {
  e.preventDefault();
  e.stopPropagation();
  fn?.(e);
}

export function stopBoundaryPointerDown(e, fn) {
  e.stopPropagation();
  fn?.(e);
}